'use client';

import { useTranslations } from 'next-intl';
import type { IFooterLinkItem } from './footer-link-groups';
import { Link } from './link';

const LEGAL_LINK_ITEMS: IFooterLinkItem[] = [
  { href: '/privacy', labelKey: 'links.privacy' },
  { href: '/cookies', labelKey: 'links.cookies' },
  { href: '/terms', labelKey: 'links.terms' },
  { href: '/dmca', labelKey: 'links.dmca' },
  { href: '/accessibility', labelKey: 'links.accessibility' },
  { href: '/delete-account', labelKey: 'links.deleteAccount' },
];

export function FooterLegalLinks(): React.JSX.Element {
  const t = useTranslations('footer');
  return (
    <nav aria-label={t('headings.legal')}>
      <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm/6">
        {LEGAL_LINK_ITEMS.map(({ href, labelKey }) => (
          <li key={href}>
            <Link
              href={href}
              className="cm-underline text-muted-foreground data-hover:text-foreground"
            >
              {t(labelKey)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
